import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {CompanyPreferencesClient} from '@client/company-preferences-client'
import {
  addingAllowed,
  deleteAllowed,
  renameAllowed
} from '@client/hub-actions-allowed'
import {PermissionsChecker} from '@client/permissions-checker'
import {MenuItemData} from '@components/common/base/menu'
import {canAdd, canEdit} from '@components/dashboard/dashboard-utils'
import {globals} from '@extensions/globals-base'
import {Project} from '@extensions/project'
import {CompanyProjectsStore} from '../company-projects-store'

export const useProjectItemMenu = (
  project: Hub,
  store: CompanyProjectsStore
): MenuItemData[] => {
  if (!canEdit(project)) {
    return []
  }

  const menu: MenuItemData[] = [
    {
      id: 'edit',
      icon: 'IconEdit',
      title: Lang.msg.rename,
      onClick: () => store.setProjectTitleEditing(project.id),
      disabled:
        !renameAllowed(project.id) || !PermissionsChecker.checkRename(project)
    }
  ]

  const settings = CompanyPreferencesClient.get(globals.getCompanyId())
  if (!settings.useOldId) {
    menu.push({
      id: 'edit-id',
      icon: 'IconEdit',
      title: Lang.msg.renameId,
      onClick: () => store.setProjectIdEditing(project.id),
      disabled:
        !renameAllowed(project.id) || !PermissionsChecker.checkRename(project)
    })
  }

  menu.push({
    id: 'users',
    icon: 'IconUsers',
    title: Lang.msg.proj.menuRoles,
    onClick: e => store.projectParticipantsOpen(project.id, e)
  })

  canAdd() &&
    menu.push({
      id: 'duplicate',
      icon: 'IconFolders',
      title: Lang.msg.duplicate,
      onClick: () => store.duplicateProject(project),
      disabled: !addingAllowed(project.id)
    })

  menu.push({
    id: 'archive',
    icon: 'IconArchive',
    title: project.complete ? Lang.msg.menuUnarchive : Lang.msg.menuArchive,
    onClick: () => store.projectsToggleArchive(project)
  })

  menu.push({
    id: 'link',
    icon: 'IconLink',
    title: Lang.msg.menuCopyLink,
    onClick: () => Project.copyLink(project)
  })

  menu.push({
    id: 'remove',
    icon: 'IconTrash',
    title: Lang.msg.delete,
    onClick: () => store.deleteProject(project),
    disabled:
      !deleteAllowed(project.id) || !PermissionsChecker.checkDeletion(project)
  })

  return menu
}
